<ng-container *transloco="let t; prefix: 'components.pay-drawer-common'">
  <ng-template #status>
    @if (!invoice()) {
      <div [ngStyle]="PaymentDrawerStyles.body | theme">{{ t("preparing-invoice") }}</div>
    } @else if (showQR()) {
      <div [ngStyle]="PaymentDrawerStyles.body | theme">{{ t("qr-title") }}</div>
    }
  </ng-template>

  <ng-template #copy>
    <app-button
      class="copy"
      [label]="t('copy')"
      icon="copy"
      [iconPosition]="themeService.buttonConfig().iconPosition"
      variant="secondary"
      stretch="fill"
      [disabled]="!invoice()"
      [loading]="!invoice()"
      (clickEvent)="copyClickedEvent.emit()"
    />
  </ng-template>

  @if (layout() === "stacked") {
    <ng-container *ngTemplateOutlet="status" />
  }
  @if (showQR()) {
    @if (invoice(); as invoice) {
      <qrcode class="qr" [qrdata]="invoice" [width]="qrWidth()" [errorCorrectionLevel]="'M'" />
    } @else {
      <ion-skeleton-text
        class="qr"
        [style.width]="qrWidth() + 'px'"
        [style.height]="qrWidth() + 'px'"
        animated
      />
    }
  }
  @if (layout() === "row") {
    <div class="side">
      <ng-container *ngTemplateOutlet="status" />
      <ng-container *ngTemplateOutlet="copy" />
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="copy" />
  }
</ng-container>
